// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__nNGIF","calendarButtons":"ClockData_calendarButtons__oVfKB"};